import React from 'react';
import Button from '@material-ui/core/Button';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const AbsoluteContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  width: 'fit-content'
}));

export const ChatContainer = styled('div')(({ theme }) => ({
  height: '100%',
  overflowY: 'auto',
  padding: theme.spacing(2),
  position: 'relative',
  scrollBehavior: 'auto'
}));

export const DateTitle = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  textAlign: 'center'
}));

export const JumpToLatestButton = styled(({ showJumpButton: _showJumpButton, ...other }) => (
  <Button {...other} />
))(({ theme, showJumpButton }) => ({
  borderRadius: theme.spacing(8),
  opacity: showJumpButton ? 0.8 : 0,
  textTransform: 'none',
  position: 'absolute',
  left: '50%',
  bottom: 0,
  transform: 'translate(-50%, -50%)',
  visibility: showJumpButton ? 'visible' : 'hidden',
  transition: 'opacity 0.5s ease-in-out',
  '&:hover': {
    opacity: 1
  }
}));
